/* eslint-disable quote-props */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from '../../../../components/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { addLocale } from 'primereact/api';

import * as actions from '../../../../store/modules/auth/actions';

import { displayErrors, converteData, formataDataMoment } from '../../../../util/diversos';
import { Input100px, Input155px, Input200px } from '../../../../styles/inputGroup';
import { fillColumns } from '../../../../components/table';

import Card from '../../../../components/card';
import store from '../../../../store/store';
import axiosAdmin from '../../../../services/axiosAdmin';
import Loading from '../../../loading';

import ConsultaNFe from '../../nfe/consultaNFe';

import ConsultaCodigoAliquotasCredPresIBSCBS from '../../cClassTrib/consultaCodigoAliquotasCredPresIBSCBS';

addLocale('pt-BR', {
  firstDayOfWeek: 0,
  dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
  monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  today: 'hoje',
  clear: 'Limpar',
});

export default function CadastroEventoNFe({ payloadCadastro, childToParentCadastro }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const id = get(payloadCadastro, 'id', 0);
  const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', null);

  const [listaTipoEventoDFe, setListaTipoEventoDFe] = useState(null);
  const [codigoEventoDFe, setCodigoEventoDFe] = useState('112110');
  const [chaveNFe, setChaveNFe] = useState(null);
  const [showConsultaNFe, setShowConsultaNFe] = useState(false);

  const [data, setData] = useState(new Date());
  const [cOrgao, setCOrgao] = useState('91');
  const [cOrgaoAutor, setCOrgaoAutor] = useState('');
  const [cnpj, setCnpj] = useState(''); // cnpj do emitente
  const [codigoSituacao, setCodigoSituacao] = useState('00');
  const [dataCancelamento, setDataCancelamento] = useState(null);
  const [dataEmissao, setDataEmissao] = useState(null);
  const [dataPrevisaoEntrega, setDataPrevisaoEntrega] = useState(null);
  const [listaIndQuitacao, setListaIndQuitacao] = useState([]);
  const [detIndQuitacao, setDetIndQuitacao] = useState(1);
  const [listaIndAceitacao, setListaIndAceitacao] = useState([]);
  const [detIndAceitacao, setDetIndAceitacao] = useState(1);
  const [flag, setFlag] = useState('D');
  const [identificador, setIdentificador] = useState('');
  const [nSeqEvento, setNSeqEvento] = useState(1);
  const [protocoloAutorizacao, setProtocoloAutorizacao] = useState('');
  const [protocoloCancelamento, setProtocoloCancelamento] = useState('');
  const [listaTpAutor, setListaTpAutor] = useState([]); // lista preenchida quando busca a nfe
  const [tpAutor, setTpAutor] = useState('1'); // 1 - empresa emitente, 2 - empresa destinararia, 3 - empresa, 5 - fisco, 6 -RFB , 9 outros orgaos

  const [showConfirmDeleteItem, setShowConfirmDeleteItem] = useState(false);
  const [itemNum, setItemNum] = useState('');
  const [itemVIBS, setItemVIBS] = useState(0);
  const [itemVCBS, setItemVCBS] = useState(0);
  const [itemQtde, setItemQtde] = useState(0);
  const [listaUnidadeMedida, setListaUnidadeMedida] = useState([]);
  const [itemUnidade, setItemUnidade] = useState('');

  const ConsultaIBS_cCredPres = ConsultaCodigoAliquotasCredPresIBSCBS;
  const ConsultaCBS_cCredPres = ConsultaCodigoAliquotasCredPresIBSCBS;
  const [itemVBC, setItemVBC] = useState(0);
  const [showConsultaIBS_cCredPres, setShowConsultaIBS_cCredPres] = useState(false);
  const [itemIBS_cCredPres, setItemIBS_cCredPres] = useState('');
  const [itemIBS_descricaoCCredPres, setItemIBS_descricaoCCredPres] = useState('');
  const [itemIBS_pCredPres, setItemIBS_pCredPres] = useState('');
  const [itemIBS_vCredPres, setItemIBS_vCredPres] = useState('');
  const [showConsultaCBS_cCredPres, setShowConsultaCBS_cCredPres] = useState(false);
  const [itemCBS_cCredPres, setItemCBS_cCredPres] = useState('');
  const [itemCBS_descricaoCCredPres, setItemCBS_descricaoCCredPres] = useState('');
  const [itemCBS_pCredPres, setItemCBS_pCredPres] = useState('');
  const [itemCBS_vCredPres, setItemCBS_vCredPres] = useState('');

  const [itemChaveDFeReferenciada, setItemChaveDFeReferenciada] = useState('');
  const [itemNumItemDFeReferenciada, setItemNumItemDFeReferenciada] = useState('');

  const [listaItemNFe, setListaItemNFe] = useState([]); // lista preenchida quando busca a nfe

  const [itemIBS_vSolicCredPres, setitemIBS_vSolicCredPres] = useState(0);
  const [itemCBS_vSolicCredPres, setitemCBS_vSolicCredPres] = useState(0);

  const [listaItem112120, setListaItem112120] = useState([]);
  const [listaItem112130, setListaItem112130] = useState([]);
  const [listaItem112140, setListaItem112140] = useState([]);
  const [listaItem211110, setListaItem211110] = useState([]);
  const [listaItem211124, setListaItem211124] = useState([]);
  const [listaItem211130, setListaItem211130] = useState([]);
  const [listaItem211140, setListaItem211140] = useState([]);
  const [listaItem211150, setListaItem211150] = useState([]);
  const [selectedItens, setSelectedItens] = useState(null);

  const colunasItemParte1 = [
    { field: 'item', header: 'item' },
    { field: 'det_nItem', header: 'Ítem na NFe', sort: true },
  ];

  const colunasItemParte2 = [
    ...colunasItemParte1,
    { field: 'det_vIBS', header: 'Valor IBS', sort: true },
    { field: 'det_vCBS', header: 'Valor CBS', sort: true },
    { field: 'det_qtde', header: 'Quantidade', sort: false },
    { field: 'det_unidade', header: 'Unidade', sort: false },
  ];

  const colunasItemCredPres = [
    ...colunasItemParte1,
    { field: 'det_vBC', header: 'Valor BC', sort: true },
    { field: 'det_gIBS_cCredPres', header: 'Cód Cred Pres IBS', sort: true },
    { field: 'det_gIBS_pCredPres', header: 'Alíq Cred Pres IBS', sort: true },
    { field: 'det_gIBS_vCredPres', header: 'Valor Cred Pres IBS', sort: true },
    { field: 'det_gCBS_cCredPres', header: 'Cód Cred Pres CBS', sort: true },
    { field: 'det_gCBS_pCredPres', header: 'Alíq Cred Pres CBS', sort: true },
    { field: 'det_gCBS_vCredPres', header: 'Valor Cred Pres CBS', sort: true },
  ];

  const colunasItemSolicCred = [
    ...colunasItemParte1,
    { field: 'det_gCredito_vCredIBS', header: 'Valor Solic Créd IBS', sort: true },
    { field: 'det_gCredito_vCredCBS', header: 'Valor Solic Créd CBS', sort: true },
  ];

  const columnsPorEvento = {
    112120: colunasItemParte2,
    112130: colunasItemParte2,
    112140: colunasItemParte2,
    211124: colunasItemParte2,
    211130: colunasItemParte2,
    211140: colunasItemParte2,
    211110: colunasItemCredPres,
    211150: colunasItemSolicCred,
  };

  const columnsSetupItem = columnsPorEvento[codigoEventoDFe] || [];

  useEffect(() => {
    let listDropdown = [];

    // listaindquitacao
    listDropdown.push({ label: '1', value: '1' });

    setDetIndQuitacao(listDropdown[0].value);

    setListaIndQuitacao(listDropdown);

    // listaindaceitacao
    listDropdown = [];
    listDropdown.push(
      { label: '0 - Não Aceite', value: '0' },
      { label: '1 - Aceite', value: '1' },
    );

    setDetIndAceitacao(listDropdown[0].value);

    setListaIndAceitacao(listDropdown);

    // lista tipoautor
    listDropdown = [];
    listDropdown.push(
      { label: '1 - Empresa Emitente', value: '1' },
    );

    setTpAutor(listDropdown[0].value);

    setListaTpAutor(listDropdown);
  }, []);

  useEffect(() => {
    async function getTipoEventoDFe() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _tipoEventoNFe } = await axiosAdmin.get('/tipoeventodfe/');

        _tipoEventoNFe.forEach(element => {
          if (element.codigo !== '110110' && element.codigo !== '110111' && element.modeloDFe === '55') {
            listDropdown.push({ label: `${element.codigo} - ${element.descricao}`, value: element.codigo });
          }
        });

        setListaTipoEventoDFe(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getTipoEventoDFe();

    async function getUnidadeMedida() {
      try {
        setIsLoading(true);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        const listDropdown = [];
        const { data: _unidadesMedida } = await axiosAdmin.get(`/unidademedida?idUsuario=${idUsuario}&cnpjEmpresa=${cnpjEmpresa}`);

        _unidadesMedida.forEach(element => {
          listDropdown.push({ label: `${element.sigla} ${element.descricao}`, sigla: element.sigla, value: element.sigla });
        });

        setListaUnidadeMedida(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getUnidadeMedida();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line consistent-return
  const childToParentConsultaNFe = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.chaveAcesso) {
        setChaveNFe(e.chaveAcesso);

        const listDropdown = [];
        const _listaItem = e.listaNFeItem;

        _listaItem.forEach(element => {
          listDropdown.push({ label: `${element.item} - ${element.produto.descricao}`, qtde: element.qcom, unidade: element.produto.unidadeMedida.sigla, value: element.item });
        });

        // console.log('listDropdown: ', listDropdown);

        setItemNum(listDropdown[0].value);
        setItemQtde(listDropdown[0].qtde);
        setItemUnidade(listDropdown[0].unidade);
        setListaItemNFe(listDropdown);
      } else {
        toast.warning('Nota Fiscal sem chave de acesso');
        return false;
      }
      setShowConsultaNFe(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    let newTitle = 'Orçamento - Cadastro';
    if (id > 0) {
      newTitle = 'Orçamento - Edição';
    }

    if (id <= 0) {
      return false;
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/eventodfe/${id}`);

        console.log('data: ', data);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          displayErrors('Acesso negado', dispatch, navigate, '/consultaeventodfe', '');
        }

        const _dataPrevisaoEntrega = converteData(data.dprevEntrega);

        const _data = converteData(data.data);

        const _dataCancelamento = converteData(data.dataCancelamento, true);
        const _dataEmissao = converteData(data.dataEmissao, true);

        setCOrgao(data.corgao);
        setCOrgaoAutor(data.corgaoAutor);// igual ao codigo da uf da chave de acesso
        setCnpj(data.cnpj); // cnpj do emitente
        setCodigoSituacao(data.codigoSituacao ? data.codigoSituacao : '00');
        setDataPrevisaoEntrega(_dataPrevisaoEntrega);
        setData(_data);
        setDataCancelamento(_dataCancelamento);
        setDataEmissao(_dataEmissao);
        setFlag(data.flag ? data.flag : 'D');
        setIdentificador(data.identificador);
        setNSeqEvento(data.nseqEvento ? data.nseqEvento : 1);
        setProtocoloAutorizacao(data.protocoloAutorizacao ? data.protocoloAutorizacao : '');
        setProtocoloCancelamento(data.protocoloCancelamento ? data.protocoloCancelamento : '');
        setTpAutor(data.tpAutor);
        setCodigoEventoDFe(data.tpEvento);
        if (data.chaveNFe) {
          setChaveNFe(data.chaveNFe);

          const nfe = await axiosAdmin.get(`/nfe/chaveacesso?idUsuario=${idUsuario}&cnpjEmpresa=${cnpjEmpresa}&chaveAcesso=${data.chaveNFe}&emissaoPropria=false`);
          if (nfe.data) {
            childToParentConsultaNFe(nfe.data[0]);
          }
        }

        const _listaItem = [];
        let contadorItem = 1;
        data.listaEventoDFeBody.forEach(element => {
          console.log('element: ', element);
          _listaItem.push({
            item: contadorItem++,
            id: element.id,
            det_nItem: element.det_nItem,
            det_vIBS: element.det_vIBS,
            det_vCBS: element.det_vCBS,
            det_qtde: element.det_qtde,
            det_unidade: element.det_unidade,
            //
            det_vBC: element.det_vBC,
            det_gIBS_cCredPres: element.det_gIBS_cCredPres,
            det_gIBS_pCredPres: element.det_gIBS_pCredPres,
            det_gIBS_vCredPres: element.det_gIBS_vCredPres,
            det_gCBS_cCredPres: element.det_gCBS_cCredPres,
            det_gCBS_pCredPres: element.det_gCBS_pCredPres,
            det_gCBS_vCredPres: element.det_gCBS_vCredPres,
            //
            det_dfeReferenciado_chaveAcesso: element.det_dfeReferenciado_chaveAcesso,
            det_dfeReferenciado_nItem: element.det_dfeReferenciado_nItem,
            //
            det_gCredito_vCredIBS: element.det_gCredito_vCredIBS,
            det_gCredito_vCredCBS: element.det_gCredito_vCredCBS,
          });
        });

        switch (data.tpEvento) {
          case '112120':
            setListaItem112120(_listaItem);
            break;
          case '112130':
            setListaItem112130(_listaItem);
            break;
          case '112140':
            setListaItem112140(_listaItem);
            break;
          case '211110':
            setListaItem211110(_listaItem);
            break;
          case '211130':
            setListaItem211130(_listaItem);
            break;
          case '211140':
            setListaItem211140(_listaItem);
            break;
          case '211124':
            setListaItem211124(_listaItem);
            break;
          case '211150':
            setListaItem211150(_listaItem);
            break;
          default:
            break;
        };
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  const listas = (codigoEventoDFe) => {
    const listaEventos = {
      '112120': listaItem112120,
      '112130': listaItem112130,
      '112140': listaItem112140,
      '211110': listaItem211110,
      '211124': listaItem211124,
      '211130': listaItem211130,
      '211140': listaItem211140,
      '211150': listaItem211150,
    };

    return listaEventos[codigoEventoDFe] || [];
  };

  // eslint-disable-next-line consistent-return
  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let _dataPrevisaoEntrega = null;
      if (dataPrevisaoEntrega) {
        _dataPrevisaoEntrega = formataDataMoment(dataPrevisaoEntrega, '-');
      }

      let _data = null;
      if (data) {
        _data = formataDataMoment(data, '-');
      }

      let _dataCancelamento = null;
      if (dataCancelamento) {
        _dataCancelamento = formataDataMoment(dataCancelamento, '-', true);
      }

      // console.log('lista item: ', listaItem);

      let _listaItem = [];
      switch (codigoEventoDFe) {
        case '112120':
          _listaItem = [...listaItem112120];
          break;
        case '112130':
          _listaItem = [...listaItem112130];
          break;
        case '112140':
          _listaItem = [...listaItem112140];
          break;
        case '211110':
          _listaItem = [...listaItem211110];
          break;
        case '211130':
          _listaItem = [...listaItem211130];
          break;
        case '211140':
          _listaItem = [...listaItem211140];
          break;
        case '211124':
          _listaItem = [...listaItem211124];
          break;
        case '211150':
          _listaItem = [...listaItem211150];
          break;
        default:
          break;
      };

      const shippingData = {
        idUsuario,
        cnpjEmpresa,
        cOrgao, // 91 para ambiente nacional e da uf quando evento de responsabilidade da uf
        cOrgaoAutor: chaveNFe.slice(0, 2), // igual ao codigo da uf da chave de acesso
        chaveNFe,
        cnpj: cnpjEmpresa, // cnpj do emitente
        codigoSituacao,
        dPrevEntrega: _dataPrevisaoEntrega,
        data: _data,
        dataCancelamento: _dataCancelamento,
        dataEmissao,
        det_indAceitacao: detIndAceitacao,
        det_indQuitacao: detIndQuitacao,
        flag,
        identificador,
        nSeqEvento,
        protocoloAutorizacao,
        protocoloCancelamento,
        tpAutor,
        tpEvento: codigoEventoDFe,
        verAplic: 'MG1.0.0',
        verEvento: '1.00',
        listaEventoDFeBodyDTO: _listaItem,
      };

      let payloadDataTableList = {};

      // console.log('shippingdata: ', shippingData);

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/eventodfe/${id}`, shippingData), 'data', {});
        payloadDataTableList.id = id + 1;
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/eventodfe', shippingData), 'data', {});
      }
      toast.success(' Evento cadastrado com sucesso');

      childToParentCadastro(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível cadastrar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentCadastro();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (cnpjEmpresa === null) {
      formErros = true;
      toast.error('Cnpj empresa não encontrado');
    }

    if (chaveNFe === null || chaveNFe === '') {
      formErros = true;
      toast.error('Chave da NFe deve ser informada.');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const handleFocus = (event) => event.target.select();

  const titulo = () => (id > 0 ? 'Evento NFe- Alteração' : 'Evento NFe - Inclusão');

  function botoesFinalizar() {
    return (
      <div className="card-header" style={{ marginLeft: '12px', marginRight: '12px', width: '98%' }}>
        <div className="row">
          <div className="col-lg-9">
            <div style={{ display: 'flex', justifyContent: 'start', position: 'relative', top: '20%' }}>
              <h5>{titulo()}</h5>
            </div>
          </div>
          <div className="col-lg-3">
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-success"
              >
                <i className="pi pi-check"></i>
                Salvar
              </button>
              <button
                onClick={handleCancel}
                type="button"
                className="btn btn-danger"
              >
                <i className="pi pi-times"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const limparCampos = () => {
    setItemVIBS(0);
    setItemVCBS(0);
    setItemQtde(0);
    setItemUnidade('UN');
    //
    setItemIBS_cCredPres('');
    setItemIBS_descricaoCCredPres('');
    setItemIBS_pCredPres('');
    setItemIBS_vCredPres('');

    setItemVBC(0);
    setItemCBS_cCredPres('');
    setItemCBS_descricaoCCredPres('');
    setItemCBS_pCredPres('');
    setItemCBS_vCredPres('');

    setItemChaveDFeReferenciada('');
    setItemNumItemDFeReferenciada('');

    setitemIBS_vSolicCredPres(0);
    setitemCBS_vSolicCredPres(0);

    setDataPrevisaoEntrega(null);
  };

  useEffect(() => {
    // limpar campos ao mudar de codigo evento
    limparCampos();
  }, [codigoEventoDFe]);

  // eslint-disable-next-line consistent-return
  const handleOkItem = () => {
    let _listaItem = [];
    switch (codigoEventoDFe) {
      case '112120':
        _listaItem = [...listaItem112120];
        break;
      case '112130':
        _listaItem = [...listaItem112130];
        break;
      case '112140':
        _listaItem = [...listaItem112140];
        break;
      case '211110':
        _listaItem = [...listaItem211110];
        break;
      case '211130':
        _listaItem = [...listaItem211130];
        break;
      case '211140':
        _listaItem = [...listaItem211140];
        break;
      case '211124':
        _listaItem = [...listaItem211124];
        break;
      case '211150':
        _listaItem = [...listaItem211150];
        break;
      default:
        break;
    };

    // console.log('lista item: ', _listaItem);

    let item = 0;
    _listaItem.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    const data = {
      item,
      det_nItem: itemNum,
      //
      det_vIBS: itemVIBS,
      det_vCBS: itemVCBS,
      det_qtde: itemQtde,
      det_unidade: itemUnidade,
      //
      det_vBC: itemVBC,
      det_gIBS_cCredPres: itemIBS_cCredPres,
      det_gIBS_pCredPres: itemIBS_pCredPres,
      det_gIBS_vCredPres: itemIBS_vCredPres,
      det_gCBS_cCredPres: itemCBS_cCredPres,
      det_gCBS_pCredPres: itemCBS_pCredPres,
      det_gCBS_vCredPres: itemCBS_vCredPres,
      //
      det_dfeReferenciado_chaveAcesso: itemChaveDFeReferenciada,
      det_dfeReferenciado_nItem: itemNumItemDFeReferenciada,
      //
      det_gCredito_vCredIBS: itemIBS_vSolicCredPres,
      det_gCredito_vCredCBS: itemCBS_vSolicCredPres,
    };

    _listaItem.push(data);

    switch (codigoEventoDFe) {
      case '112120':
        setListaItem112120(_listaItem);
        break;
      case '112130':
        setListaItem112130(_listaItem);
        break;
      case '112140':
        setListaItem112140(_listaItem);
        break;
      case '211110':
        setListaItem211110(_listaItem);
        break;
      case '211130':
        setListaItem211130(_listaItem);
        break;
      case '211140':
        setListaItem211140(_listaItem);
        break;
      case '211124':
        setListaItem211124(_listaItem);
        break;
      case '211150':
        setListaItem211150(_listaItem);
        break;
      default:
        break;
    };

    limparCampos();
  };

  const onHideConsultaNFe = () => {
    setShowConsultaNFe(false);
  };

  const onHideConsultaIBS_cCredPres = () => {
    setShowConsultaIBS_cCredPres(false);
  };

  const childToParentIBS_cCredPres = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.codigo) {
        setItemIBS_cCredPres(e.codigo);
      }
      if (e.descricao) {
        setItemIBS_descricaoCCredPres(e.descricao);
      }
      setShowConsultaIBS_cCredPres(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const onHideConsultaCBS_cCredPres = () => {
    setShowConsultaCBS_cCredPres(false);
  };

  const childToParentCBS_cCredPres = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.codigo) {
        setItemCBS_cCredPres(e.codigo);
      }
      if (e.descricao) {
        setItemCBS_descricaoCCredPres(e.descricao);
      }
      setShowConsultaCBS_cCredPres(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  // eslint-disable-next-line consistent-return
  async function handleBuscarIBS_cCredPres(e) {
    try {
      setIsLoading(true);

      if (e.length <= 0) {
        setItemIBS_descricaoCCredPres('');
        return false;
      }

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/credpresibscbs?idUsuario=${idUsuario}&cnpjEmpresa=${cnpjEmpresa}`;

      params = `${params}&codigo=${e}`;

      const response = await axiosAdmin.get(params);
      if (response.data.length > 0) {
        setItemIBS_descricaoCCredPres(response.data[0].descricao);
      } else {
        setItemIBS_descricaoCCredPres('');
        toast.info('Nenhum classificação com esse código encontrado para crédito presumido');
      }
    } catch (err) {
      console.log('err: ', err);
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  // eslint-disable-next-line consistent-return
  async function handleBuscarCBS_cCredPres(e) {
    try {
      setIsLoading(true);

      if (e.length <= 0) {
        setItemCBS_descricaoCCredPres('');
        return false;
      }

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/credpresibscbs?idUsuario=${idUsuario}&cnpjEmpresa=${cnpjEmpresa}`;

      params = `${params}&codigo=${e}`;

      const response = await axiosAdmin.get(params);
      if (response.data.length > 0) {
        setItemCBS_descricaoCCredPres(response.data[0].descricao);
      } else {
        setItemCBS_descricaoCCredPres('');
        toast.info('Nenhum classificação com esse código encontrado para crédito presumido');
      }
    } catch (err) {
      console.log('err: ', err);
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const cancelDeleteItem = () => {
    setShowConfirmDeleteItem(false);
  };

  const confirmDeleteItem = () => {
    const item = selectedItens.item;

    // console.log('item: ', item);

    if (item > 0) {
      let _listaItem = [];
      switch (codigoEventoDFe) {
        case '112120':
          _listaItem = [...listaItem112120];
          break;
        case '112130':
          _listaItem = [...listaItem112130];
          break;
        case '112140':
          _listaItem = [...listaItem112140];
          break;
        case '211110':
          _listaItem = [...listaItem211110];
          break;
        case '211130':
          _listaItem = [...listaItem211130];
          break;
        case '211140':
          _listaItem = [...listaItem211140];
          break;
        case '211124':
          _listaItem = [...listaItem211124];
          break;
        case '211150':
          _listaItem = [...listaItem211150];
          break;
        default:
          break;
      };

      const index = _listaItem.indexOf(_listaItem.find(element => element.item === item));

      if (index >= 0) {
        _listaItem.splice(index, 1);

        _listaItem.forEach(element => {
          if (element.item > item) {
            const _index = _listaItem.indexOf(element);

            _listaItem[_index].item = _listaItem[_index].item - 1;
          }
        });

        switch (codigoEventoDFe) {
          case '112120':
            setListaItem112120(_listaItem);
            break;
          case '112130':
            setListaItem112130(_listaItem);
            break;
          case '112140':
            setListaItem112140(_listaItem);
            break;
          case '211110':
            setListaItem211110(_listaItem);
            break;
          case '211130':
            setListaItem211130(_listaItem);
            break;
          case '211140':
            setListaItem211140(_listaItem);
            break;
          case '211124':
            setListaItem211124(_listaItem);
            break;
          case '211150':
            setListaItem211150(_listaItem);
            break;
          default:
            break;
        };

        setShowConfirmDeleteItem(false);
      }
    }
  };

  const confirmDialogFooterItem = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteItem} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteItem} />
    </div>
  );

  const handleDeleteItem = (e) => {
    const item = e.det_nItem;

    if (item > 0) {
      setSelectedItens(e);
      setShowConfirmDeleteItem(true);
    } else {
      toast.warning('Por favor, selecione o item para exclusão');
    }
  };

  // eslint-disable-next-line arrow-body-style
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="row col-12">
        <div className="col-lg-3">
          <button
            type="button"
            title="Visualizar PDF"
            className="btn btn-danger"
            style={{ borderRadius: '15px' }}
            onClick={() => handleDeleteItem(rowData)}
          >
            <i className="pi pi-trash"></i>
          </button>
        </div>
      </div>
    )
  };

  return (
    <div>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteItem}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterItem}
        onHide={() => setShowConfirmDeleteItem(false)}
      >
        <p>
          Excluir o item?
        </p>
      </Dialog>

      <Dialog
        header="Consulta de Código das Alíquotas do Crédito Presumido do IBS/CBS"
        visible={showConsultaIBS_cCredPres}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaIBS_cCredPres()}
      >
        <ConsultaIBS_cCredPres menuMode={false} childToParent={childToParentIBS_cCredPres} />
      </Dialog>

      <Dialog
        header="Consulta de Código das Alíquotas do Crédito Presumido do IBS/CBS"
        visible={showConsultaCBS_cCredPres}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaCBS_cCredPres()}
      >
        <ConsultaCBS_cCredPres menuMode={false} childToParent={childToParentCBS_cCredPres} />
      </Dialog>

      <Dialog
        header="Consulta de Notas Fiscais"
        visible={showConsultaNFe}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaNFe()}
      >
        <ConsultaNFe menuMode={false} childToParent={childToParentConsultaNFe} somenteLeitura />
      </Dialog>

      <Card style={{ marginTop: '16px' }}>
        <div className="row form-elo">
          { botoesFinalizar() }
        </div>
        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={data}
                onChange={(e) => { setData(e.value); }}
              />
            </div>
          </div>
          <div className="col-3">

          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Nro Sequêncial do Evento
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={nSeqEvento}
                onValueChange={e => setNSeqEvento(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Eventos
              </Input155px>
              <Dropdown
                options={listaTipoEventoDFe}
                value={codigoEventoDFe}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setCodigoEventoDFe(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                NFe
              </Input155px>
              <InputText
                disabled
                maxLength={44}
                value={chaveNFe}
                onChange={e => setChaveNFe(e.target.value)}
              />
              <Button
                icon="pi pi-search"
                className="p-button-warning"
                onClick={() => setShowConsultaNFe(true)}
              />
              <Button
                icon="pi pi-times"
                className="p-button-danger"
                onClick={() => {
                  setChaveNFe('');
                  setListaItemNFe([]);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="estamparia-orcamento-item">
            {(codigoEventoDFe === '112120'
              || codigoEventoDFe === '112130'
              || codigoEventoDFe === '112140'
              || codigoEventoDFe === '211110'
              || codigoEventoDFe === '211124'
              || codigoEventoDFe === '211130'
              || codigoEventoDFe === '211140'
              || codigoEventoDFe === '211150') && (
              <DataTable
                value={listas(codigoEventoDFe)}
                size="small"
                stripedRows
                responsiveLayout="scroll"
                sortField="item"
                selectionMode="single"
                selection={selectedItens}
                onSelectionChange={e => setSelectedItens(e.value)}
                selectableRows
                dataKey="item"
                emptyMessage="Nenhum Ítem cadastrado"
              >
                {fillColumns(columnsSetupItem)}
                <Column body={actionBodyTemplate} exportable={false} style={{ width: '90px' }}></Column>
              </DataTable>
            )}
          </div>
          <br />
        </div>
        {codigoEventoDFe === '112110' && (
          <div className="row form-elo">
            <div className="col-6">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Indicador de Quitação
                </Input155px>
                <Dropdown
                  options={listaIndQuitacao}
                  value={detIndQuitacao}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => setDetIndQuitacao(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
        {(codigoEventoDFe === '112120'
          || codigoEventoDFe === '112130'
          || codigoEventoDFe === '112140'
          || codigoEventoDFe === '211110'
          || codigoEventoDFe === '211124'
          || codigoEventoDFe === '211130'
          || codigoEventoDFe === '211140'
          || codigoEventoDFe === '211150') && (

            <div className="row form-elo">
              <div className="col-11">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Item da NF-e
                  </Input155px>
                  <Dropdown
                    options={listaItemNFe}
                    value={itemNum}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setItemNum(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-1">
                <button
                  type="button"
                  title="Ok - Inclusão de Item do evento"
                  className="btn btn-success"
                  onClick={handleOkItem}
                >
                  <i className="pi pi-check"></i>
                  Incluir
                </button>
              </div>
            </div>
        )}
        {(codigoEventoDFe === '112120'
          || codigoEventoDFe === '112130'
          || codigoEventoDFe === '112140'
          || codigoEventoDFe === '211124'
          || codigoEventoDFe === '211130'
          || codigoEventoDFe === '211140') && (
          <div className="row form-elo">
            <div className="col-2">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Valor IBS
                </Input100px>
                <InputNumber
                  mode="currency"
                  inputId="currency-br"
                  currency="BRL"
                  locale="pt-BR"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  value={itemVIBS}
                  onValueChange={e => setItemVIBS(e.target.value)}
                />
              </div>
            </div>
            <div className="col-2">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Valor CBS
                </Input100px>
                <InputNumber
                  mode="currency"
                  inputId="currency-br"
                  currency="BRL"
                  locale="pt-BR"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  value={itemVCBS}
                  onValueChange={e => setItemVCBS(e.target.value)}
                />
              </div>
            </div>
            <div className="col-2">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Quantidade
                </Input100px>
                <InputNumber
                  mode="decimal"
                  inputId="minmaxfraction"
                  minFractionDigits={3}
                  maxFractionDigits={3}
                  value={itemQtde}
                  onValueChange={e => setItemQtde(e.target.value)}
                  onFocus={handleFocus}
                />
              </div>
            </div>
            <div className="col-2">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Unidade
                </Input100px>
                <Dropdown
                  autoFocus
                  options={listaUnidadeMedida}
                  value={itemUnidade}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={e => setItemUnidade(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
        {codigoEventoDFe === '112150' && (
          <div className="row form-elo">
            <div className="col-3">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Data Previsão Entrega
                </Input155px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={dataPrevisaoEntrega}
                  onChange={(e) => setDataPrevisaoEntrega(e.value)}
                />
              </div>
            </div>
          </div>
        )}
        {codigoEventoDFe === '211110' && (
          <>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Valor BC do Item
                  </Input155px>
                  <InputNumber
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={itemVBC}
                    onValueChange={e => setItemVBC(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Cód Classif IBS
                  </Input155px>
                  <InputText
                    maxLength={2}
                    value={itemIBS_cCredPres}
                    onChange={e => setItemIBS_cCredPres(e.target.value)}
                    onBlur={e => handleBuscarIBS_cCredPres(e.target.value)}
                  />
                  <Button
                    icon="pi pi-search"
                    className="p-button-warning"
                    onClick={() => setShowConsultaIBS_cCredPres(true)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <InputText
                    disabled
                    maxLength={255}
                    value={itemIBS_descricaoCCredPres}
                  />
                </div>
              </div>
              <div className="col-2">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Aliquota %
                  </Input100px>
                  <InputNumber
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={itemIBS_pCredPres}
                    onValueChange={e => setItemIBS_pCredPres(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-2">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Valor Créd Pres
                  </Input100px>
                  <InputNumber
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={itemIBS_vCredPres}
                    onValueChange={e => setItemIBS_vCredPres(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Cód Classif CBS
                  </Input155px>
                  <InputText
                    maxLength={2}
                    value={itemCBS_cCredPres}
                    onChange={e => setItemCBS_cCredPres(e.target.value)}
                    onBlur={e => handleBuscarCBS_cCredPres(e.target.value)}
                  />
                  <Button
                    icon="pi pi-search"
                    className="p-button-warning"
                    onClick={() => setShowConsultaCBS_cCredPres(true)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <InputText
                    disabled
                    maxLength={255}
                    value={itemCBS_descricaoCCredPres}
                  />
                </div>
              </div>
              <div className="col-2">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Aliquota %
                  </Input100px>
                  <InputNumber
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={itemCBS_pCredPres}
                    onValueChange={e => setItemCBS_pCredPres(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-2">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Valor Créd Pres
                  </Input100px>
                  <InputNumber
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={itemCBS_vCredPres}
                    onValueChange={e => setItemCBS_vCredPres(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {(codigoEventoDFe === '211128'
          || codigoEventoDFe === '212110'
          || codigoEventoDFe === '212120') && (
          <div className="row form-elo">
            <div className="col-6">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Indicador de Aceitação
                </Input155px>
                <Dropdown
                  options={listaIndAceitacao}
                  value={detIndAceitacao}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => setDetIndAceitacao(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
        {codigoEventoDFe === '211150' && (
          <div className="row form-elo">
            <div className="col-3">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Valor Solic Créd IBS
                </Input155px>
                <InputNumber
                  mode="currency"
                  inputId="currency-br"
                  currency="BRL"
                  locale="pt-BR"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  value={itemIBS_vSolicCredPres}
                  onValueChange={e => setitemIBS_vSolicCredPres(e.target.value)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Valor Solic Créd CBS
                </Input155px>
                <InputNumber
                  mode="currency"
                  inputId="currency-br"
                  currency="BRL"
                  locale="pt-BR"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  value={itemCBS_vSolicCredPres}
                  onValueChange={e => setitemCBS_vSolicCredPres(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
